"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _types = require("./types");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DefaultLogger = void 0;
var DefaultLogger = /*#__PURE__*/function () {
  function DefaultLogger() {
    _classCallCheck(this, DefaultLogger);
  }
  return _createClass(DefaultLogger, [{
    key: "log",
    value: function log(a, b) {
      a === _types.LogLevel.DEBUG ? console.debug(b) : a === _types.LogLevel.INFO ? console.info(b) : a === _types.LogLevel.WARNING ? console.warn(b) : a === _types.LogLevel.ERROR ? console.error(b) : void 0;
    }
  }]);
}();
exports.DefaultLogger = DefaultLogger;